import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class OrderApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.ORDER);
  }

  getOrderLines(orderId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${orderId}/order-lines/`,
    );
  }

  cancelOrders(orderId, shipmentLineIds, refund, isRejectNotFound) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${orderId}/cancel/`,
      {
        shipment_line_id_list: shipmentLineIds,
        refund: refund,
        is_reject_not_found: isRejectNotFound,
      },
      { skipGlobal403: true },
    );
  }

  connectOrders(orderId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${orderId}/relation-connect/`,
      {},
    );
  }

  getOrderHistory(orderId) {
    return this.httpClient.get(`${this.getResourceUrl()}${orderId}/history/`);
  }

  getOrderExport(params) {
    return this.httpClient.get(`${this.getResourceUrl()}export/`, { params });
  }

  getUnfulfillableOrderExport(params) {
    return this.httpClient.get(
      `${this.getResourceUrl()}unfulfillable/export/`,
      {
        params,
      },
    );
  }

  patchUnfulfillableOrderRelationConnect() {
    const url = `${this.getResourceUrl()}relation-connect/`;

    return this.httpClient.patch(url, {});
  }

  transferOrder(orderId, targetWarehouseId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${orderId}/transfer/`,
      {
        target_warehouse_id: targetWarehouseId,
      },
    );
  }
}

export default new OrderApi();
